<template>
    <div>
        <h3>Letter Template</h3>
        <div class="">
            <loader v-if="loading"/>
            <form v-if="!loading" class="form form-horizontal" @submit.prevent>
                <div class="form-group">
                    <label class="col-md-3 control-label">Template Name</label>
                    <div class="col-md-6">
                        <input class="form-control" type="text" v-model="letterTemplate.templateName" />
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-3 control-label">Template Type</label>
                    <div class="col-md-6">
                        <select class="form-control" v-model="letterTemplate.letterTemplateTypeId">
                            <option disabled :value="null">Select Template Type</option>
                            <option v-for="type in templateTypeList" :value="type.id" :key="type.id">{{type.description}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-3 control-label">Generate on Workflow</label>
                    <div class="col-md-6">
                        <select class="form-control" v-model="letterTemplate.workflowStatusId">
                            <option :value="null">None</option>
                            <option disabled :value="null">--- Fieldwork Request (FWR) ---</option>
                            <option v-for="status in fieldworkWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">FWR - {{status.description}}</option>
                            <option disabled :value="null">------ File Search (FIS) ------</option>
                            <option v-for="status in fileSearchWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">FIS - {{status.description}}</option>
                            <option disabled :value="null">----- Investigation (INV) -----</option>
                            <option v-for="status in investigationWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">INV - {{status.description}}</option>
                            <option disabled :value="null">- Cultural Resource Recording (CRR) -</option>
                            <option v-for="status in crrWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">CRR - {{status.description}}</option>
                            <option disabled :value="null">-------- Isolate (ISO) --------</option>
                            <option v-for="status in isolateWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">ISO - {{status.description}}</option>
                            <option disabled :value="null">-- Site Number Request (SNR) --</option>
                            <option v-for="status in siteNumberRequestWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">SNR - {{status.description}}</option>
                            <option disabled :value="null">---- Building Survey (BUS) ----</option>
                            <option v-for="status in buildingSurveyWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">BUS - {{status.description}}</option>
                            <option disabled :value="null">------ Undertaking (UND) ------</option>
                            <option v-for="status in undertakingWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">UND - {{status.description}}</option>
                            <option disabled :value="null">------------- MOA -------------</option>
                            <option v-for="status in moaWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">MOA - {{status.description}}</option>
                            <option disabled :value="null">------------- PA --------------</option>
                            <option v-for="status in paWfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">PA - {{status.description}}</option>
                            <option disabled :value="null">--- E106 Compliance (E106) ----</option>
                            <option v-for="status in e106WfsList" :value="status.workflowStatusId" :key="status.workflowStatusId">E106 - {{status.description}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-3 control-label">Secondary Condition</label>
                    <div class="col-md-6">
                        <select class="form-control" v-model="letterTemplate.secondaryConditionId">
                            <option :value="null">None</option>
                            <option :value="1">Undertaking is Notify and Proceed</option>
                            <option :value="2">Undertaking is Notify and Proceed &amp; BLM is Lead Agency</option>
                            <option :value="3">Undertaking is Notify and Proceed &amp; USFS is Lead Agency</option>
                        </select>
                    </div>
                </div>
                <button class="btn btn-primary" type="button" name="dataReference" v-on:click="$refs['dataFieldModal'].open()">Data Fields Reference</button>
                <div class="container">
                    <editor id="editor" v-model="letterTemplate.templateBody" :init="editor.options"></editor>
                </div>
                <div class="form-group spacer">
                    <div class="col-sm-2">
                        <button type="button" name="saveTemplate" class="btn btn-primary" v-on:click="saveTemplate">Save Template</button>
                    </div>
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                        <button name="button1" class="btn btn-primary" v-on:click="getLetterPreview">Preview Sample Letter</button>
                    </div>
                </div>
            </form>
            <modal ref="dataFieldModal">
                <div slot="header" class="row">
                    <h3 class="pull-left">Data Fields Reference</h3>
                    <button class="btn pull-right" v-on:click="$refs['dataFieldModal'].close()">X</button>
                </div>
                <div slot="body">
                    <v-client-table :data="tableData" :columns="gridSpec.columns" :options="gridSpec.options">
                        <template slot="insert" slot-scope="props">
                            <div style="text-align: center;">
                                <a class="fa fa-paste" style="font-size: 18px;" v-on:click="copyAndInsertDataField(props.row.dataField)"></a>
                            </div>
                        </template>
                    </v-client-table>
                </div>
                <div slot="footer">
                    <div class="row">
                        <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['dataFieldModal'].close()">Close</button>
                    </div>
                </div>
            </modal>
            <modal ref="letterPreviewModal">
                <div slot="header" class="row">
                    <h3 class="pull-left align-bottom">Letter Body Preview</h3>
                    <button class="btn pull-right" v-on:click="$refs['letterPreviewModal'].close(), closeLetterAlert()">X</button>
                </div>
                <div slot="body">
                    <loader v-if="letterPreviewLoading" />
                    <div v-if="!letterPreviewLoading">
                        <editor id="editorPreview" v-model="editorPreview.previewContent" :init="editorPreview.options"></editor>
                    </div>
                    <div style="margin-top: 10px; width: 99%;">
                        <div class="alert alert-success alert-dismissible" v-bind:class="{ 'hidden' : letterAlertHidden }" role="alert">
                            <button type="button" class="close" v-on:click="closeLetterAlert()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            Letter is being generated.  It will be downloaded to your browser's Downloads folder in a few moments.
                        </div>
                    </div>
                </div>
                <div slot="footer" class="">
                    <div class="row">
                        <button type="button" class="btn btn-primary col-sm-3" v-on:click="generateLetter">Generate Letter</button>
                        <button class="btn btn-primary col-sm-3 pull-right" type="button" name="cancel" v-on:click="$refs['letterPreviewModal'].close(), closeLetterAlert()">Close</button>
                    </div>
                </div>
            </modal>
        </div>
        <div class="spacer" v-if="isDebug">
            <h3>Debug</h3>
            <div class="">
                Body Template:<br/>
                <textarea id="footer" rows="6" style="width: 1024px;" v-model="letterTemplate.templateBody" /><br/>
            </div>
        </div>
    </div>
</template>
<script>
    import loggingService from '../services/util/loggingService'
    import letterTemplateService from '../services/letterTemplateService'
    import workflowService from '../services/workflowService'
    import mediaService from '@/services/mediaService'
    import tinymce from 'tinymce/tinymce'

    import modal from '@/components/Modal.vue'
    import loader from '../components/Loader.vue'
    import editor from '@tinymce/tinymce-vue'

    export default {
        components: {
            loader,
            modal,
            editor
        },
        data: function () {
            return {
                isDebug: false,
                loading: true,
                letterPreviewLoading: false,
                letterTemplate: {},
                templateTypeList: [],
                fieldworkWfsList: [],
                fileSearchWfsList: [],
                investigationWfsList: [],
                siteNumberRequestWfsList: [],
                crrWfsList: [],
                isolateWfsList: [],
                buildingSurveyWfsList: [],
                undertakingWfsList: [],
                moaWfsList: [],
                paWfsList: [],
                e106WfsList: [],
                editor: {
                    options: {
                        selector: '#editor',
                        height: 500,
                        plugins: 'lists paste table',
                        oninit: 'setPlainText',
                        forced_root_block: false,
                        browser_spellcheck: true,
                        menubar: 'edit format',
                        toolbar: 'undo redo | fontselect fontsizeselect | bullist table',
                        table_default_attributes: {
                            border: '1',
                            width: '50%',
                            cellspacing: '0'
                        },
                        paste_postprocess: (plugin, args) => {
                            args.node.querySelectorAll('table').forEach(tableNode => {
                                tableNode.setAttribute('border', '1')
                                tableNode.setAttribute('cellspacing', '0')
                            })
                        },
                        content_style: 'body { font-family: Arial; }',
                        remove_linebreaks: false
                    }
                },
                editorPreview: {
                    options: {
                        selector: '#editorPreview',
                        height: 480,
                        width: 800,
                        plugins: 'lists paste table',
                        oninit: 'setPlainText',
                        forced_root_block: false,
                        menubar: 'edit format',
                        toolbar: 'undo redo | fontselect fontsizeselect | bullist table',
                        table_default_attributes: {
                            border: '1',
                            width: '50%',
                            cellspacing: '0'
                        },
                        paste_postprocess: (plugin, args) => {
                            args.node.querySelectorAll('table').forEach(tableNode => {
                                tableNode.setAttribute('border', '1')
                                tableNode.setAttribute('cellspacing', '0')
                            })
                        },
                        content_style: 'body { font-family: Arial; }'
                    },
                    previewContent: ''
                },
                generateLetterPdfDto: {
                    letterTemplateTypeId: null,
                    projectId: 1,
                    FieldWorkRequestId: 1,
                    fileSearchId: 1,
                    investigationId: 1,
                    siteNumberRequestId: 1,
                    culturalResourceRecordingId: 2,
                    isolateId: 1,
                    buildingSurveyId: 1,
                    undertakingId: 1,
                    pdfHtmlFileDto: {
                        baseUrl: this.$http,
                        headerHtml: '',
                        bodyHtml: '',
                        footerHtml: ''
                    }
                },
                gridSpec: {
                    columns: ['insert', 'dataField', 'dataFieldDescription'],
                    options: {
                        dateFormat: 'YYYY-MM-DD',
                        perPage: 10,
                        perPageValues: [10, 25, 50, 100],
                        headings: {
                            dataField: 'Data Field',
                            dataFieldDescription: 'Data Field Name'
                        },
                        orderBy: {
                            ascending: true,
                            column: 'dataField'
                        }
                    }
                },
                letterAlertHidden: true
            }
        },
        computed: {
            workflowEnum: function () {
                return workflowService.WorkflowEnum
            },
            tableData: function () {
                return letterTemplateService.DataFieldReferenceList
            }
        },
        mounted () {
            this.log('mounted')
            this.loadLookup()
            this.loadWorkflowStatus()
            this.loadData()
        },
        methods: {
            log (message) {
                loggingService.log(this.isDebug, 'LetterTemplate', message)
            },
            loadLookup () {
                this.log('load lookup')
                letterTemplateService.listLetterTemplateType(this.$http).then(response => {
                    this.templateTypeList = response.data
                })
            },
            loadWorkflowStatus () {
                this.log('load workflow status')
                workflowService.listAllWorkflowStatus(this.$http).then(response => {
                    this.fieldworkWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.FieldworkRequest })
                    this.fileSearchWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.FileSearch })
                    this.investigationWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.Investigation })
                    this.siteNumberRequestWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.SiteNumberRequest })
                    this.crrWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.CulturalResourceRecording })
                    this.isolateWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.Isolate })
                    this.buildingSurveyWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.BuildingSurvey })
                    this.undertakingWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.Undertaking })
                    this.moaWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.Moa })
                    this.paWfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.Pa })
                    this.e106WfsList = response.data.filter(x => { return x.workflowId === this.workflowEnum.E106Compliance })
                })
            },
            loadData () {
                this.log('load data')
                if (this.$route.params.letterTemplateId) {
                    this.log('loading letterTemplate Id' + this.$route.params.letterTemplateId)
                    letterTemplateService.get(this.$http, this.$route.params.letterTemplateId).then(response => {
                        this.letterTemplate = response.data
                        this.loading = false
                    })
                } else {
                    this.log('creating new letterTemplate')
                    this.createNewLetterTemplate()
                    this.loading = false
                }
            },
            createNewLetterTemplate () {
                this.letterTemplate = {
                    letterTemplateTypeId: null,
                    templateName: '',
                    templateBody: ''
                }
                return this.letterTemplate
            },
            saveTemplate () {
                this.log('saving letter template')
                letterTemplateService.put(this.$http, this.letterTemplate).then(response => {
                    if (response.data.objectList && response.data.objectList.length > 0) {
                        this.$router.push('/LetterTemplate/' + response.data.objectList[0].letterTemplateId)
                        this.loadData()
                    } else {
                        this.log('server validation failed on save')
                    }
                })
            },
            getLetterPreview () {
                this.$refs['letterPreviewModal'].open()
                this.letterPreviewLoading = true
                this.generateLetterPdfDto.letterTemplateTypeId = this.letterTemplate.letterTemplateTypeId
                this.generateLetterPdfDto.pdfHtmlFileDto.bodyHtml = this.letterTemplate.templateBody
                letterTemplateService.letterTemplateDataFieldMerge(this.$http, this.generateLetterPdfDto).then(response => {
                    this.editorPreview.previewContent = response.data.pdfHtmlFileDto.bodyHtml
                    this.letterPreviewLoading = false
                })
            },
            generateLetter () {
                this.generateLetterPdfDto.pdfHtmlFileDto.bodyHtml = this.editorPreview.previewContent

                this.letterAlertHidden = false
                mediaService.generateLetterPdf(this.$http, this.generateLetterPdfDto).then(response => {
                    mediaService.saveFileToDownload(response, 'letter.pdf')
                })
            },
            closeLetterAlert () {
                this.letterAlertHidden = true
            },
            copyAndInsertDataField: function (dataField) {
                if (window.clipboardData && window.clipboardData.setData) {
                    // IE specific code path to prevent textarea being shown while dialog is visible.
                    this.$refs['dataFieldModal'].close()
                    //paste the dataField text to the tinymce editor
                    tinymce.get('editor').insertContent(dataField)
                    //copy dataField to clipboard
                    return window.clipboardData.setData('Text', dataField)
                } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
                    var textarea = document.createElement('textarea')
                    textarea.textContent = dataField
                    textarea.style.position = 'fixed'  // Prevent scrolling to bottom of page in MS Edge.
                    document.body.appendChild(textarea)
                    textarea.select()
                    try {
                        this.$refs['dataFieldModal'].close()
                        //paste the dataField text to the tinymce editor
                        tinymce.get('editor').insertContent(dataField)
                        //copy dataField to clipboard
                        return document.execCommand('copy')  // Security exception may be thrown by some browsers.
                    } catch (ex) {
                        console.warn('Copy to clipboard failed.', ex)
                        return false
                    } finally {
                        document.body.removeChild(textarea)
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// LetterTemplate.vue?07296d10